import React, { useCallback, useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import i18next from 'i18next';

import useStyles from 'style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import {
  getTargetFieldCategoryOptions,
  VariableContext,
  TargetFieldContext,
} from 'services/common/CalculatorUtils';
import CalculatorSelectInput from 'containers/administration/calculator/form/calculatorInputs/CalculatorSelectInput';
import TargetFieldData from './Data';

const TargetField = ({ fieldName, readOnly = false }) => {
  const { classes } = useStyles();
  const targetFieldCategoryOptions = getTargetFieldCategoryOptions();
  const { onVariableChangeCallBack, currentVariable} = useContext(
    VariableContext
  );

  const formMethods = useFormContext();
  const { setValue, clearErrors } = formMethods;

  const selectedTargetFieldCategory = useWatch({
    name: `${fieldName}.target_field_category`,
  });

  const onTargetFieldCategoryChange = useCallback(
    (newValue) => {
      setValue(`${fieldName}.target_field_data`, {});
      clearErrors(`${fieldName}.target_field_data`);
    },
    [fieldName, clearErrors, setValue]
  );

  const targetFieldcontext = React.useMemo(
    () => ({
      selectedTargetFieldCategory: selectedTargetFieldCategory,
      readOnly: readOnly,
    }),
    [selectedTargetFieldCategory, readOnly]
  );

  return (
    <>
      <CalculatorSelectInput
        fieldName={`${fieldName}.target_field_category`}
        label={``}
        isRequired
        placeholder={i18next.t(
          `calculator.dialog.create.placeholder.selectValue`
        )}
        options={targetFieldCategoryOptions}
        onChange={(newValue) => {
          onTargetFieldCategoryChange(newValue);
          onVariableChangeCallBack(currentVariable, 'target_field_category');
        }}
        validate={() => {
          return null;
        }}
        variant="standard"
        labelVariant="standard"
        className={classes.inputPathVariableItem}
        disabled={readOnly}
      />

      <TargetFieldContext.Provider value={targetFieldcontext}>
        <TargetFieldData fieldName={`${fieldName}.target_field_data`} readOnly={readOnly}/>
      </TargetFieldContext.Provider>
    </>
  );
};

export default TargetField;
